import React, { createContext, useContext, useState, ReactNode } from 'react'
import useMediaQuery from '@/hooks/use-media-query'
import { breakpoints } from '@/styles'

interface SidebarContextType {
  isSidebarOpen: boolean
  setIsSidebarOpen: (a: boolean) => void
}

interface SidebarProviderProps {
  children: ReactNode
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined)

export const SidebarProvider: React.FC<SidebarProviderProps> = ({ children }) => {
  const isTouch = useMediaQuery('(pointer: coarse)')
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.desktopSmall})`)
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => (!isTouch ? !isMobile : false))

  return (
    <SidebarContext.Provider value={{ isSidebarOpen, setIsSidebarOpen }}>
      {children}
    </SidebarContext.Provider>
  )
}

export const useSidebarContext = (): SidebarContextType => {
  const context = useContext(SidebarContext)
  if (!context) {
    throw new Error('useSidebarContext must be used within a SidebarProvider')
  }
  return context
}
